import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const LOGO_URL =
  "https://storage.readdy-site.link/project_files/45b3cfca-45db-4e89-81dd-5e962535454e/ed46beda-b2e2-4e49-8fe8-982740950b38_-2026-03-26-2.12.17.png?v=503321e01f3f9a222c0dcb8439e9e8a5";

// SNS リンク。実 URL が用意でき次第 href を設定する。
// href 未設定（ダミー）のものは表示しない方針（href="#" のデッドリンクを出さない）。
const SOCIAL_LINKS: { label: string; icon: string; href?: string }[] = [
  { label: "X (Twitter)", icon: "ri-twitter-x-line" },
  { label: "Instagram", icon: "ri-instagram-line" },
  { label: "LinkedIn", icon: "ri-linkedin-line" },
];

export default function Footer() {
  const { t } = useTranslation("common");
  const activeSocials = SOCIAL_LINKS.filter((s) => s.href);
  return (
    <footer style={{ background: "#2C5F4F", color: "#fff" }}>
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="flex flex-col lg:flex-row gap-12 justify-between">
          {/* Left: Logo + Mission */}
          <div className="max-w-xs">
            <div className="flex items-center gap-2 mb-4">
              <img
                src={LOGO_URL}
                alt="EachTeach"
                className="rounded-lg object-contain"
                style={{ width: 42, height: 42, background: "#F5EDD6" }}
              />
              <span
                style={{
                  fontFamily: "'Outfit', sans-serif",
                  fontWeight: 700,
                  fontSize: 18,
                  color: "#fff",
                }}
              >
                EachTeach
              </span>
            </div>
            <p
              style={{
                fontFamily: "'Noto Serif JP', serif",
                fontSize: 14,
                color: "rgba(255,255,255,0.8)",
                lineHeight: 1.9,
              }}
            >
              {t("footer.mission")}
            </p>
          </div>

          {/* Right: Links */}
          <div className="flex flex-col sm:flex-row gap-10">
            <div>
              <p
                style={{
                  fontFamily: "'Noto Sans JP', sans-serif",
                  fontWeight: 700,
                  fontSize: 13,
                  color: "rgba(255,255,255,0.6)",
                  letterSpacing: "0.08em",
                  textTransform: "uppercase",
                  marginBottom: 14,
                }}
              >
                {t("footer.community")}
              </p>
              <div className="flex flex-col gap-2">
                {[
                  { label: t("footer.communityRegister"), path: "/register" },
                  { label: t("footer.services"), path: "/services" },
                ].map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    className="cursor-pointer whitespace-nowrap"
                    style={{
                      fontFamily: "'Noto Sans JP', sans-serif",
                      fontSize: 13,
                      color: "rgba(255,255,255,0.75)",
                      transition: "color 0.2s",
                    }}
                    onMouseEnter={(e) =>
                      ((e.currentTarget as HTMLAnchorElement).style.color = "#ffffff")
                    }
                    onMouseLeave={(e) =>
                      ((e.currentTarget as HTMLAnchorElement).style.color = "rgba(255,255,255,0.75)")
                    }
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <p
                style={{
                  fontFamily: "'Noto Sans JP', sans-serif",
                  fontWeight: 700,
                  fontSize: 13,
                  color: "rgba(255,255,255,0.6)",
                  letterSpacing: "0.08em",
                  textTransform: "uppercase",
                  marginBottom: 14,
                }}
              >
                {t("footer.about")}
              </p>
              <div className="flex flex-col gap-2">
                {[
                  { label: t("footer.aboutEachTeach"), path: "/" },
                  { label: t("footer.philosophy"), path: "/#philosophy" },
                ].map((link) => (
                  <Link
                    key={link.label}
                    to={link.path}
                    className="cursor-pointer whitespace-nowrap"
                    style={{
                      fontFamily: "'Noto Sans JP', sans-serif",
                      fontSize: 13,
                      color: "rgba(255,255,255,0.75)",
                      transition: "color 0.2s",
                    }}
                    onMouseEnter={(e) =>
                      ((e.currentTarget as HTMLAnchorElement).style.color = "#ffffff")
                    }
                    onMouseLeave={(e) =>
                      ((e.currentTarget as HTMLAnchorElement).style.color = "rgba(255,255,255,0.75)")
                    }
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div style={{ borderTop: "1px solid rgba(255,255,255,0.15)", marginTop: 48, paddingTop: 24 }}>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p
              style={{
                fontFamily: "'Noto Sans JP', sans-serif",
                fontSize: 12,
                color: "rgba(255,255,255,0.5)",
              }}
            >
              &copy; {new Date().getFullYear()} EachTeach. All rights reserved.
            </p>
            {activeSocials.length > 0 && (
              <div className="flex items-center gap-4">
                {activeSocials.map((social) => (
                  <a
                    key={social.label}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="cursor-pointer"
                    style={{
                      width: 32,
                      height: 32,
                      borderRadius: "50%",
                      border: "1px solid rgba(255,255,255,0.3)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "rgba(255,255,255,0.7)",
                      fontSize: 13,
                      transition: "border-color 0.2s, color 0.2s",
                    }}
                    aria-label={social.label}
                    onMouseEnter={(e) => {
                      (e.currentTarget as HTMLAnchorElement).style.borderColor = "#fff";
                      (e.currentTarget as HTMLAnchorElement).style.color = "#fff";
                    }}
                    onMouseLeave={(e) => {
                      (e.currentTarget as HTMLAnchorElement).style.borderColor =
                        "rgba(255,255,255,0.3)";
                      (e.currentTarget as HTMLAnchorElement).style.color = "rgba(255,255,255,0.7)";
                    }}
                  >
                    <i className={social.icon} />
                  </a>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
}
